/*
 * @Author: Roman
 * @Date: 2023-01-04 15:50:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-20 14:57:20
 * @FilePath: \qpmn-site\src\app\core\error\catch-error.ts
 * @Description: 
 */
import { IMessageDialogOptions } from "@qpUIs/qp-message-dialog/qp-message-dialog-options.interface";
import { BusinessException, ICatchErrorConfig } from ".";

interface ICatchError {
    new(config?: ICatchErrorConfig): (target: object, propertyName: string, descriptor: any) => void;
}

/**
 * @deprecated
 * @param config 
 * @returns 
 */
function CatchError(config?: ICatchErrorConfig): (target: object, propertyName: string, descriptor: any) => void {
    return function (target: object, propertyName: string, descriptor: any): void {
        const method = descriptor.value;
        descriptor.value = function (...args: any) {
            try {
                return method.apply(this, args);
            } catch (error) {
                if (error instanceof BusinessException) {
                    let title = config && config.title ? config.title : error.name;
                    let content = error.message;
                    // todo:$translate 必须在使用到 装饰器的地方注入
                    if (this && this.$translate != null) {
                        title = this.$translate.instant(title);
                        // 若配置了Code对应的错误信息,则采用Code信息作为提示信息,否则直接使用传入的错误信息
                        let _msg = this.$translate.instant(error.code);
                        if (_msg && _msg != String(error.code)) {
                            content = _msg;
                        }
                    }

                    let confirmCallback = config && config.confirmCallback ? config.confirmCallback : undefined;
                    let cancelCallback = config && config.cancelCallback ? config.cancelCallback : undefined;
                    let extendCfg = config && config.extendCfg ? config.extendCfg : undefined;

                    let promptType = config?.type ? config.type : "warning";

                    if (window.qpAlertPrompt && window.qpAlertPrompt[promptType]) {
                        window.qpAlertPrompt[promptType](title, content, confirmCallback, cancelCallback, extendCfg);
                    } else {
                        alert("Unhandle Error: " + title + "\r\n    " + content);
                    }

                    // if (this && this.qpMessageDialog != null) {
                    //     let configs: IMessageDialogOptions = {
                    //         title: title,
                    //         content: content,
                    //     };

                    //     if (error.code) {
                    //         configs.code = error.code;
                    //     }

                    //     if (error.message) {
                    //         configs.msg = error.message;
                    //     }
                        
                    //     this.qpMessageDialog[promptType](configs);
                    // } else {
                    //     console.error("need to inject qpMessageDialog!");
                    // }
                } else {
                    throw error;
                }
            }
        };

        descriptor.CatchError = config;
    }
}

export { ICatchError, CatchError }